import React from "react";
import PropTypes from "prop-types";

import { TextValidator } from "react-material-ui-form-validator"
import Grid from "@mui/material/Grid";

import StringHelper from "../../../../../helpers/StringHelper";
import Rules from "../../../../../config/rules";

class AbstractTextInput extends React.Component {

    getInput = () => {
        const merged = { ...this.props, ...this.specs};
        let {
            inputProps,
            dataName,
            validators,
            errorMessages,
            displayCondition,
            xs, sm,
            handleChange,
            enqueueSnackbar,
            closeSnackbar,
            textTransform,
            isOptional,
            isOptionalLabel,
            label,
            isMoreThan0,
            isLessThan100,
            isLoading,
            isValidInput,
            updateLoading,
            updateFoundCities,
            confirmEmail,
            confirmPassword,
            validatorListener,

            ...props
        } = merged;

        // Default input props
        inputProps = inputProps ? inputProps : { maxLength:30 };

        // Set default classname if empty
        inputProps.className = inputProps.className ? inputProps.className : '';

        // Add loader if required
        inputProps.className = this.props.isLoading ? inputProps.className + ' is-loading' : inputProps.className.replace(/is-loading/g,'');
        inputProps.className = this.props.isValidInput ? inputProps.className.replace(/is-valid/g,'') + ' is-valid' : inputProps.className.replace(/is-valid/g,'');

        // set specific input props as object
        let specInputProps = { inputProps };

        return(


                    ( displayCondition===undefined ||  displayCondition===true ) &&
                    <TextValidator
                        label={this.getLabel()}
                        validators={this.getValidators()}
                        errorMessages={this.getErrorMessages()}
                        onChange={this.onChange}
                        {...props}
                        {...specInputProps}
                        value={this.getValue()}
                        fullWidth
                    />

        )
    }

    onChange = (event) =>{
        // Change value and formated it
        if(this.props.textTransform || (this.specs && this.specs.textTransform) ){

            switch(this.props.textTransform || (this.specs && this.specs.textTransform) ){
                case 'lowercase' : this.onChangeFormater(event,'getLowercase'); break;
                case 'uppercase' : this.onChangeFormater(event,'getUpperCase');break;
                case 'regular' : this.onChangeFormater(event,'getRegularCase');break;
                case 'capitalize' : this.onChangeFormater(event,'getCapitalize');break;
                default : this.onChangeFormater(event,'getRegularCase');break;
            }

        } else {
            this.onChangeFormater(event,'getRegularCase');
        }
    };

    onChangeFormater = (event,formater) => {

        // get cursor position to restore it
        let currenteventCursorPosition = event.target.selectionStart;

        // Check if it is last position
        let isLastPosition = (event.target.value.length===currenteventCursorPosition);

        event.target.value = Rules[formater](event.target.value);

        // Update the value
        this.props.handleChange(event);

        // update cursor position only if not the last charactere
        if(!isLastPosition)
            event.target.setSelectionRange(currenteventCursorPosition, currenteventCursorPosition);
    };

    getLabel = () =>{
        // If prop label is set override default label
        if(this.props.label) this.label=this.props.label;
        // Return label with optional if option is set
        return this.props.isOptionalLabel === true && this.props.isOptional===true ? <>{this.label} <i>(facultatif)</i></> : this.label;
    };

    getValue = () =>{
        //if not value defined return empty
        if(!this.props.value) return '';

        switch(this.props.textTransform || (this.specs && this.specs.textTransform) ){
            case 'lowercase' : return this.props.value.toLowerCase();
            case 'uppercase' : return this.props.value.toUpperCase();
            case 'regular' : return this.props.value;
            case 'capitalize': return this.props.value.charAt(0).toUpperCase() + this.props.value.slice(1);
            default : return this.props.value;
        }
    };

    getValidators = () =>{
        if(this.props.validators){
            return this.validators ? this.props.validators.concat(this.validators) : this.props.validators
        }
        return this.validators;
    };

    getErrorMessages = () =>{
        if(this.props.errorMessages){
            return this.errorMessages ? this.props.errorMessages.concat(this.errorMessages) : this.props.errorMessages
        }
        return this.errorMessages;
    };

    render() {
        return this.getInput();
    }
}


AbstractTextInput.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired]),
    handleChange: PropTypes.func,
    isOptionalLabel: PropTypes.bool,
    isOptional: PropTypes.bool,
    isLoading: PropTypes.bool,
    textTransform: PropTypes.string,
    isValidInput: PropTypes.bool,
}

export default AbstractTextInput;
